<template>
  <div class="dialog-scroll">
    <el-dialog
      :visible.sync="dialogVisible"
      class="search-popup"
      @close="resetForms"
      :before-close="handleDialogClose">
      <div class="title">{{ $t("title.system.resourceRelated.resourceRelated") }}</div>
      <!-- 検索エリア start -->

      <el-form @submit.native.prevent :model="query" ref="resourcePopupRuleForm">
        <el-row :gutter="16">
          <el-col class="col">
            <el-form-item prop="roomId" class="input_item">
              <el-input
                maxlength="50"
                size="small"
                v-model="searchResourceName"
              >
              </el-input>
            </el-form-item>
            <div class="form-group" @click="filterResult">
              <narrow-down>
                {{ $t("button.common.narrow") }}
              </narrow-down>
              <cancel-narrow-down @click="clearSearchParams" class="margin-left-8 link-primary">
                {{ $t("button.common.cancelNarrow") }}
              </cancel-narrow-down>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 検索エリア end -->

      <!-- 检索結果 start -->
      <div v-if="(filterResultSelectOptions == null || filterResultSelectOptions.length == 0) && !showLoading" class="no-data">
        {{ $t('message.common.NoData') }}
      </div>
      <div v-else id="popup-resource-search-result" class="master-table-type searchResult">
        <el-checkbox-group
          v-model="selectedResourceID" @change="onChange">
          <el-checkbox
            v-for="item in filterResultSelectOptions"
            :key="item.resourceID"
            :label="item.resourceID"
            size="small"
            class="resource-popup-radio">
            <div>
              {{ item.resourceName }}
            </div>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <!-- 检索結果 end -->

      <div class="res-dialog-button">
        <el-button class="res-dialog-save" v-show="isEdit && filterResultSelectOptions != null && filterResultSelectOptions.length > 0" @click="saveResourceRelated">
          {{ $t('button.common.data.save') }}
        </el-button>
        <el-button class="res-dialog-cancel" v-show="!showLoading" @click="handleDialogClose">
          {{ $t('button.common.data.cancel') }}
        </el-button>
      </div>
    </el-dialog>
    <loading-dialog :dialogVisible="showLoading" />
    <el-dialog-prompt
      :centerDialogVisibleParam.sync="centerDialogVisibleIsShow"
      :msgParam="msgParam"
      @on-isPassParam="isPassParam">
    </el-dialog-prompt>
  </div>

</template>

<script>
import SystemManageApi from "@/api/SystemManageApi";
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown";
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown";
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import elDialogPrompt from "@/components/common/el-dialog-prompt";

const EVENT_ON_SELECTED = "on-selected";

export default {
  components: {
    narrowDown,
    cancelNarrowDown,
    LoadingDialog,
    elDialogPrompt
  },
  name: "ResourceSearchPopup",
  props: {
    roomId: {
      type: String,
      default: null
    },
    /**
     * 区分
     * 01：会議室
     * 02：指定席
     */
    type: {
      type: String,
      default: null
    },
    /**
     * リソース区分
     * 01：Goolgle
     * 02：Outlook
     */
    resourceType: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isEdit: false,
      isShow: false,
      showLoading: false,
      query: {
        roomId: null,
        type: null,
        resourceType: null,
      },
      searchResult: {
        body: [],
      },
      securityDeviceSelectOptions: [],
      filterResultSelectOptions: [],
      isSearching: false,
      dialogVisible: false,
      msgParam: this.$t("message.common.validation.updateMessage",{
        field: this.$t("label.system.meetingRoom.create.resourceRelated")
      }),
      centerDialogVisibleIsShow: false,
      selectedResource: {
        resourceID: null,
        resourceName: null,
        resourceEmail: null
      },
      selectedResourceID: [],
      oldSelectedResourceID: "",
      searchResourceName: null,
      userInfo: {},
    };
  },
  watch: {
    visible: function (value) {
      if (this.type == "01") {
        this.$authCheck("020901")
        this.isEdit = this.$checkAuth("020902")
      } else if (this.type == "02") {
        this.$authCheck("040801")
        this.isEdit = this.$checkAuth("040802")
      }
      this.dialogVisible = value;
      if (this.dialogVisible) {
        this.query.type = this.type
        this.query.roomId = this.roomId
        this.query.resourceType = this.resourceType
        this.loadInfo()
      }
    },
  },
  methods: {

    loadInfo() {
      this.userInfo = this.$getLoginInfo()
      this.showLoading = true

      let request = {
        orgID: this.userInfo.orgId,
        resourceType: this.query.resourceType,
        resourceName: this.searchResourceName
      };

      // 区分＝01：会議室または区分＝02：指定席
      if (this.query.type === '01' ||this.query.type === '02' ) {

        if (this.query.type === '01') {

          // 区分＝01：会議室
          SystemManageApi.getMeetingResource(this.query.roomId, request)
            .catch(() => {
              this.showLoading = false
              this.$messageIotError(this.$t('message.common.error.ERR_RESOURCE_GET_MSG'))
            })
            .then(({ data }) => {
              if( data.statusCode == "Success" ) {
                if (data.body != null) {

                  if (data.body.resourceInfo != null) {
                    this.securityDeviceSelectOptions = [];
                    this.filterResultSelectOptions = [];
                    this.searchResult.body = data.body.resourceInfo;
                    for (let i = 0; i < this.searchResult.body.length; i++) {
                      this.securityDeviceSelectOptions.push({
                        resourceID: this.searchResult.body[i].resourceID,
                        resourceName: this.searchResult.body[i].resourceName,
                        resourceEmail: this.searchResult.body[i].resourceEmail
                      });
                      this.filterResultSelectOptions.push({
                        resourceID: this.searchResult.body[i].resourceID,
                        resourceName: this.searchResult.body[i].resourceName,
                        resourceEmail: this.searchResult.body[i].resourceEmail
                      });
                    }
                  }

                  if (data.body.resourceRelatedInfo != null) {

                    const selBool = this.securityDeviceSelectOptions.filter((val) => { return val.resourceID == data.body.resourceRelatedInfo.resourceID})

                    if (selBool.length != 0) {

                      for (let i = 0; i < this.securityDeviceSelectOptions.length; i++) {
                        let result = this.securityDeviceSelectOptions[i];
                        if (data.body.resourceRelatedInfo.resourceID === result.resourceID) {
                          this.selectedResourceID.push(data.body.resourceRelatedInfo.resourceID)
                          this.onChange()
                        }
                      }
                    }

                  }
                }
              } else {
                this.$messageIotError(this.$t('message.common.error.ERR_RESOURCE_GET_MSG'))
              }

            }).finally(() => {
              this.showLoading = false
              this.isShow = true;
            });

        } else if (this.query.type === '02') {

          // 区分＝02：指定席
          SystemManageApi.getFixDeskResource(this.query.roomId, request)
            .catch(() => {
              this.showLoading = false
              this.$messageIotError(this.$t('message.common.error.ERR_RESOURCE_GET_MSG'))
            })
            .then(({ data }) => {
              if( data.statusCode == "Success" ) {
                if (data.body != null) {

                  if (data.body.resourceInfo != null) {
                    this.securityDeviceSelectOptions = [];
                    this.filterResultSelectOptions = [];
                    this.searchResult.body = data.body.resourceInfo;
                    for (let i = 0; i < this.searchResult.body.length; i++) {
                      this.securityDeviceSelectOptions.push({
                        resourceID: this.searchResult.body[i].resourceID,
                        resourceName: this.searchResult.body[i].resourceName,
                        resourceEmail: this.searchResult.body[i].resourceEmail
                      });
                      this.filterResultSelectOptions.push({
                        resourceID: this.searchResult.body[i].resourceID,
                        resourceName: this.searchResult.body[i].resourceName,
                        resourceEmail: this.searchResult.body[i].resourceEmail
                      });
                    }
                  }

                  if (data.body.resourceRelatedInfo != null) {

                    const selBool = this.securityDeviceSelectOptions.filter((val) => { return val.resourceID == data.body.resourceRelatedInfo.resourceID})

                    if (selBool.length != 0) {

                      for (let i = 0; i < this.securityDeviceSelectOptions.length; i++) {
                        let result = this.securityDeviceSelectOptions[i];
                        if (data.body.resourceRelatedInfo.resourceID === result.resourceID) {
                          this.selectedResourceID.push(data.body.resourceRelatedInfo.resourceID)
                          this.onChange()
                        }
                      }
                    }

                  }
                }
              } else {
                this.$messageIotError(this.$t('message.common.error.ERR_RESOURCE_GET_MSG'))
              }

            }).finally(() => {
              this.showLoading = false
              this.isShow = true;
            });
        }
      }

    },

    // 絞り込み
    filterResult(){
      this.loadInfo()
      // if (this.searchResourceName == null) {
      //   this.filterResultSelectOptions = this.securityDeviceSelectOptions
      // } else {

      //   this.filterResultSelectOptions = [];
      //   for (let i = 0; i < this.securityDeviceSelectOptions.length; i++) {
      //     if (this.securityDeviceSelectOptions[i].resourceName.includes(this.searchResourceName)) {
      //       this.filterResultSelectOptions.push(this.securityDeviceSelectOptions[i]);
      //     }
      //   }
      // }
    },
    resetForms() {
      this.$refs['resourcePopupRuleForm'].resetFields()
    },
    //保存
    saveResourceRelated(){
      this.centerDialogVisibleIsShow = true
    },

    //保存API
    doneSaveResourceRelated(){
      this.centerDialogVisibleIsShow = false

      let resourceRelated = {
        resourceType: this.query.resourceType,
        resourceID: this.selectedResource.resourceID,
        resourceName: this.selectedResource.resourceName,
        resourceEmail: this.selectedResource.resourceEmail
      }
      this.centerDialogVisibleIsShow = true
      if (this.query.type === '01') {
        // 区分＝01：会議室
        SystemManageApi.updateMeetingResource(this.query.roomId, resourceRelated)
          .catch((error) => {
            errorCodeMsg(error, this)
            this.showLoading = false
          })
          .then(({data}) => {

            if(data.statusCode == "Success") {
              this.showLoading = false
              this.saveSuccess();
              this.$emit(EVENT_ON_SELECTED, this.selectedResourceID);
              this.$emit("update:visible", false);
              this.handleDialogClose()
            } else if (data.statusCode == "Failure.ErrExistRelated") {
              this.$messageIotError(this.$t('message.common.error.ERR_EXIST_RELATED_MSG', {
                field: this.$t("label.system.meetingRoom.create.meetingRoom")
              }))
            } else if (data.statusCode == "Failure.ErrOpeningRelated") {
              this.$messageIotError(this.$t('message.common.error.ERR_OPENINIG_RELATED_MSG', {
                field: this.$t("label.system.meetingRoom.create.meetingRoom")
              }))
            } else {
              this.$messageIotError("リソース関連の保存は失敗しました。")
            }
          })
          .finally(() => {});
      } else if (this.query.type === '02') {
        // 区分＝02：指定席
        SystemManageApi.updateFixDeskResource(this.query.roomId, resourceRelated)
          .catch((error) => {
            errorCodeMsg(error, this)
            this.showLoading = false
          })
          .then(({data}) => {

            if(data.statusCode == "Success") {
              this.showLoading = false
              this.saveSuccess();
              this.$emit(EVENT_ON_SELECTED, this.selectedResourceID);
              this.$emit("update:visible", false);
              this.handleDialogClose()
            } else if (data.statusCode == "Failure.ErrExistRelated") {
              this.$messageIotError(this.$t('message.common.error.ERR_EXIST_RELATED_MSG', {
                field: this.$t("label.system.fixdesk.edit.fixDesk")
              }))
            } else if (data.statusCode == "Failure.ErrOpeningRelated") {
              this.$messageIotError(this.$t('message.common.error.ERR_OPENINIG_RELATED_MSG', {
                field: this.$t("label.system.fixdesk.edit.fixDesk")
              }))
            } else {
              this.$messageIotError("リソース関連の保存は失敗しました。")
            }
          })
          .finally(() => {});
      }

    },

    isPassParam(param){
      if(param){
        this.doneSaveResourceRelated();
      }
    },

    //保存成功Message
    saveSuccess() {
      this.$messageIotSuccess(this.$t("message.common.saveSuccess", {
        field: this.$t("label.system.meetingRoom.create.resourceRelated"),
      }));
    },

    onChange() {

      let deleteResourceID = "";
      for (let i = 0; i < this.selectedResourceID.length; i++) {
        if (this.selectedResourceID[i] != this.oldSelectedResourceID) {
          this.oldSelectedResourceID = this.selectedResourceID[i]
          var selectResou = this.filterResultSelectOptions.filter((val) => { return val.resourceID == this.selectedResourceID[i]})
          this.selectedResource = selectResou[0]
        } else {
          deleteResourceID = this.selectedResourceID[i]
        }
      }

      if (deleteResourceID != "") {
        this.selectedResourceID.splice(this.selectedResourceID.indexOf(deleteResourceID), 1)
      }

      if (this.selectedResourceID.length == 0) {
        this.oldSelectedResourceID = null
        this.selectedResource = {
          resourceID: null,
          resourceName: null,
          resourceEmail: null
        }
      }
    },

    /**
     * clear
     */
    clearSearchParams: function () {
      this.searchResourceName = null;
      this.filterResultSelectOptions = this.securityDeviceSelectOptions
      this.filterResult();
    },

    handleDialogClose: function () {
      this.showLoading = false
      this.dialogVisible = false;
      this.$emit("update:visible", false);
      this.query.roomId = null;
      this.query.type = null;
      this.query.resourceType = null;
      this.searchResourceName = null;
      this.searchResult.body = [];
      this.securityDeviceSelectOptions = [];
      this.filterResultSelectOptions = [];
      this.selectedResourceID = [];
      this.selectedResource = null;
      this.oldSelectedResourceID = null;
      this.isShow = false;
    },


  },
};
</script>

<style lang="scss" scoped>
.title {
  height: 60px;
  font-size: 24px;
  // color: #2699fb;
}

.el-select {
  line-height: 42px;
  width: 100px;
  font-size: 12px;
  height: 18px;
  border-radius: 8px;
  // overflow: hidden;
  color: #fff;

  ::v-deep.el-input__inner {
    border: none;
    // line-height: 24px;
    background-color: #f2f2ed;
    color: #525250;
    // font-size: 15px !important;
    // padding-left: 20px;
    box-shadow: -2px -2px 5px #fff,
      5px 5px 8px #e6e6e1;
  }
  ::placeholder {
    color: #525250;
  }
}

.search-popup {
  ::v-deep  .el-dialog {
    width: 1024px;
    height: 700px;
    background-color: #f2f2ed;
    border-radius: 3px !important;
    ::v-deep .el-dialog__header {
      height: 50px;
      ::v-deep .el-dialog__body {
        padding: 0px 24px 0px 19px;
      }
    }
  }
}

.left-input {
  margin-top: 13px;
  width: 200px;
}
.right-input {
  margin-top: 13px;
  margin-left: 16px;
  width: 200px;
  height: 22px;
}
.col {
  display: flex;
  flex-direction: row;
}
::v-deep .el-form-item__content {
  line-height: 22px;
}
.label {
  // color: #2699fb;
  font-size: 12px;
}

.btn-operate {
  margin: 0 5px 0 0;
}
::v-deep .detail-button{
  button {
    width: 100%;
  }
  .my-button{
    width: 134px;
  }
}
::v-deep .detail-button .my-button {
  margin-left: 5px;
}
::v-deep .detail-button .my-button {
  width: 100%;
  height: 40px;
  line-height: 0;
}

// add by mxq
.input_item {
  margin-right: 20px;
  ::v-deep.el-input .el-input__inner {
    width: 296px;
    height: 44px !important;
    border-radius: 8px !important;
    background: #f2f2ed;
    border: none;
    box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
      4px 5px 5px #e6e6e1 inset, 4px 5px 5px #e6e6e1 inset;
  }
}

::v-deep.el-icon-close {
  color: rgb(0, 0, 0);
}
.button_title {
  font-size: 12px;
  position: relative;
  bottom: 6px;
}
.search-common {
  display: block;
  //float: right;
  text-align: right;
  margin-top: 36px;
  margin-bottom: 20px;
}

.res-dialog-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.res-dialog-save {
  margin-left: 0;
  margin-right: 0;
  margin-top: 6px;
  padding: 10px;
  gap: 10px;
  width: 188px;
  height: 40px;
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  color: #FFFFFF;
  background: #329CA6;
  border: none;
  box-shadow: -4px -4px 5px #FFFFFF, 3px 3px 6px #B8B8AD;
  border-radius: 8px;
}
.res-dialog-save:hover {
  opacity: 0.8;
}
.res-dialog-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.res-dialog-cancel {
  margin-left: 0;
  margin-right: 0;
  margin-top: 20px;
  font-family: 'Hiragino Kaku Gothic Pro', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 11px;
  color: #329CA6;
  border: none;
  background: none;
}
.res-dialog-cancel:hover {
  opacity: 0.8;
}
.res-dialog-cancel:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
::v-deep .resource-popup-radio {
  display: block;
  font-size: 12px;
  margin-top: 2%;
}
.searchResult {
  margin-top: 30px;
  margin-bottom: 30px;
}
.no-data {
  text-align: center;
  margin-top: 5%;
  color: #909399;
}
</style>
